import app from "../App/App";
import { getAuth } from "firebase/auth";

const auth = getAuth(app);

export default auth;
